import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

export default function Terms() {
  return (
    <>
      <main className="legal-page">
        <div className="container">
          <Link to="/" className="legal-back">← Back to Ripple</Link>
          <h1 className="legal-title">Terms of Service</h1>
          <p className="legal-date">Last updated: May 24, 2026</p>

          <div className="legal-body">
            <p className="legal-lead">
              By downloading or using Ripple, you agree to these terms.
            </p>

            <div>
              <h2 className="legal-section-title">1. License</h2>
              <p className="legal-text">
                Ripple is provided as-is for personal, non-commercial use. You may not copy,
                modify, reverse-engineer, or redistribute any part of the app.
              </p>
            </div>

            <div>
              <h2 className="legal-section-title">2. User conduct</h2>
              <p className="legal-text">
                The app is intended for puzzle enjoyment. Any attempt to manipulate game data,
                exploit the app, or interfere with its operation is prohibited.
              </p>
            </div>

            <div>
              <h2 className="legal-section-title">3. Disclaimer of warranties</h2>
              <p className="legal-text">
                Ripple is provided "as is" without warranty of any kind. We do not guarantee
                uninterrupted or error-free operation.
              </p>
            </div>

            <div>
              <h2 className="legal-section-title">4. Limitation of liability</h2>
              <p className="legal-text">
                To the fullest extent permitted by law, we are not liable for any damages arising
                from your use of Ripple.
              </p>
            </div>

            <div>
              <h2 className="legal-section-title">5. Updates</h2>
              <p className="legal-text">
                We may update the app and these terms at any time. Continued use of the app
                constitutes acceptance of updated terms.
              </p>
            </div>

            <div>
              <h2 className="legal-section-title">6. Governing law</h2>
              <p className="legal-text">
                These terms are governed by the laws of your local jurisdiction.
              </p>
            </div>

            <div>
              <h2 className="legal-section-title">7. Contact</h2>
              <p className="legal-text">
                Questions? Email: <a href="mailto:mimzeslami@gmail.com">mimzeslami@gmail.com</a>
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
